import { Product, ProductType } from '@inter-ikea-storageone/range';
import TypeFilter from './TypeFilter';
import { useSelector } from 'react-redux';
import { getProductsForGroup } from 'ducks/products';

const BaseCabinetsTypeFilter = () => {
  const products = useSelector(getProductsForGroup);

  const options = [
    {
      id: 'all',
      name: 'storageone.filterOptionAll',
      filter: (products: Product[]) =>
        products.filter(p =>
          [
            ProductType.KNOXHULT_CABINET_ASM,
            ProductType.KNOXHULT_SINK_CABINET_ASM,
            ProductType.KNOXHULT_SINK_AND_OVEN_CABINET_ASM,
            ProductType.KNOXHULT_CORNER_CABINET_ASM,
            ProductType.KNOXHULT_NICHE_CABINET_ASM
          ].includes(p.type)
        )
    },
    {
      id: 'corner-cabinets',
      name: 'storageone.filterOptionCornerCabinet',
      filter: (products: Product[]) =>
        products.filter(p => p.type === ProductType.KNOXHULT_CORNER_CABINET_ASM)
    },
    {
      id: 'sink-cabinets',
      name: 'storageone.filterOptionCabinetForSink',
      filter: (products: Product[]) =>
        products.filter(p =>
          [
            ProductType.KNOXHULT_SINK_CABINET_ASM,
            ProductType.KNOXHULT_SINK_AND_OVEN_CABINET_ASM
          ].includes(p.type)
        )
    },
    {
      id: 'niche-cabinets',
      name: 'storageone.filterOptionForFreestandingAppliance',
      filter: (products: Product[]) =>
        products.filter(p => p.type === ProductType.KNOXHULT_NICHE_CABINET_ASM)
    },
    {
      id: 'oven-cabinets',
      name: 'storageone.filterOptionForOvenAndHob',
      filter: (products: Product[]) =>
        products.filter(p => p.type === ProductType.KNOXHULT_SINK_AND_OVEN_CABINET_ASM)
    }
  ].filter(option => option.filter(products).length > 0);

  return <TypeFilter options={options} />;
};

export default BaseCabinetsTypeFilter;
